module.exports = __webpack_public_path__ + "static/img/quxiaojingyin.e39101d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/quxiaojingyin.png
// module id = nR42
// module chunks = 24